import React, { memo, useCallback } from 'react';

import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import { ConstructionTestIds } from '../../../../Construction.testIds';

const RowReviewButton = ({ drawRequestId, onReview }) => {
  const onClick = useCallback(
    event => {
      event.stopPropagation();
      onReview(drawRequestId);
    },
    [onReview, drawRequestId],
  );

  return (
    <Button
      data-testid={ConstructionTestIds.DRAW_ROW_REVIEW_BUTTON}
      size="small"
      variant="outlined"
      onClick={onClick}
    >
      Review
    </Button>
  );
};

RowReviewButton.propTypes = {
  drawRequestId: PropTypes.string.isRequired,
  onReview: PropTypes.func.isRequired,
};

export default memo(RowReviewButton);
